export default {
    "name": "DeleteDashboardReport",
    "kind": "HoudiniMutation",
    "hash": "af6cbbc176c1200192a26211f78d8d8d8aa8170dde978c8a4f2b46742ae5958f",

    "raw": `mutation DeleteDashboardReport($deleteDashboardReportId: Int!) {
  deleteDashboardReport(id: $deleteDashboardReportId) {
    id
    message
    success
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "deleteDashboardReport": {
                "type": "DeleteDashboardReportResponse",
                "keyRaw": "deleteDashboardReport(id: $deleteDashboardReportId)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "message": {
                            "type": "String",
                            "keyRaw": "message",
                            "nullable": true,
                            "visible": true
                        },

                        "success": {
                            "type": "Boolean",
                            "keyRaw": "success",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "deleteDashboardReportId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=3c1b6380b35252bb5dd9045ad8cdb1269907bbad303bbad1e64a7c0b70f12bc6";